import { z } from 'zod';
export const PAYROLL_EVENT_DETAIL_VIEWS = ['list', 'feed'] as const;
export type PayrollEventDetailView = (typeof PAYROLL_EVENT_DETAIL_VIEWS)[number];
export const SearchSchema = z.object({
  /** 選択中のステップ。未指定ならすべての Step を表示する。 */
  stepId: z.string().optional(),
  /**
   * 詳細を開いているタスク。Feed 表示では未指定なら先頭タスクを表示し、
   * List 表示では未指定のとき Step カード一覧を表示する。
   */
  taskId: z.string().optional(),
  view: z.enum(PAYROLL_EVENT_DETAIL_VIEWS).default('list')
});